module.exports = __webpack_public_path__ + "img/icon-login-profile.a5ef896c.svg";